import appStore from 'store';
import api from './api';
import { STATUS_TYPES } from './constants';
import LANGUAGE from 'common/languages';

const store = {
  namespaced: true,
  state: {
    projects: [],
    coinTypeList: [],
    totalCount: 0,
    editingProject: null,
    pagination: {
      page: 1,
      size: 25
    },
    languageList: Object.keys(LANGUAGE).map(item => {
      return {
        value: item.toString(),
        label: LANGUAGE[item]
      };
    })
  },
  getters: {
    projectList: state =>
      state.projects.map(item => ({
        ...item,
        __status: STATUS_TYPES[item.status]
      }))
  },
  mutations: {
    setList(state, payload) {
      state.projects = payload.list;
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setCoinTypeList(state, payload) {
      state.coinTypeList = payload;
    },
    setEditingProject(state, payload) {
      state.editingProject = payload;
    }
  },
  actions: {
    getList({ commit }, query) {
      api.getList(query).then(({ data }) => {
        commit('setList', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    },
    getCoinTypeList({ commit }) {
      api.getCoinTypeList().then(({ data }) => {
        commit('setCoinTypeList', data);
      });
    },
    create(context, data) {
      return api.create(data);
    },
    update(context, data) {
      return api.update(data);
    },
    deletes(context, data) {
      return api.deletes(data);
    },
    startDivident(context, data) {
      return api.startDivident(data);
    },
    endDivident(context, data) {
      return api.endDivident(data);
    },
    Onestart(context, data) {
      return api.Onestart(data);
    }
  }
};

appStore.registerModule('userdividend', store);
